import React from 'react';
import { styled, Divider } from '@teko/ui';
import { OrderProductLine } from '../OrderProductLine/OrderProductLine.es.js';

const StyledDivider = styled(Divider)`
  width: 96%;
  margin: 0 auto;
`;
const OrderProductList = ({
  products,
  showGiftQty = true
}) => {
  return /* @__PURE__ */ React.createElement("div", null, products.map((product, index) => {
    return /* @__PURE__ */ React.createElement(React.Fragment, {
      key: product.sku
    }, /* @__PURE__ */ React.createElement(OrderProductLine, {
      product,
      showGiftQty
    }), index < products.length - 1 && /* @__PURE__ */ React.createElement(StyledDivider, null));
  }));
};

export { OrderProductList };
